module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "activ-deci animated fadeIn light-dark-int",
    style: (_vm.estilos),
    attrs: {
      "tabindex": "1",
      "id": "pregunta-select",
      "role": "alert"
    }
  }, [_vm._t("default")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d622d460","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/actividades/ActividadDeciSelec.vue
// module id = 1049
// module chunks = 1